import { IDataContextProvider } from "@refinedev/core/dist/contexts/data/IDataContext";
import { AxiosInstance } from "axios";
import axAPI from "../../../api/axios-instance";
import { DataProvider } from "@refinedev/core";
import qs from "qs";
import { generateFilter } from "../../../helpers";

export const clubsTagsDataProvider = (
  apiUrl: string,
  httpClient: AxiosInstance = axAPI
): DataProvider =>
  <IDataContextProvider>{
    getList: async ({ filters }) => {
      const url = "/cms/tags/getTeamTag";
      const queryFilters = generateFilter(filters);

      const filterQuery = qs.stringify(queryFilters);
      try {
        const { data } = await httpClient.get(`${url}?${filterQuery}`);
        return {
          data: data.hashTags,
        };
      } catch (e) {
        return Promise.reject(e);
      }
    },
    getOne: async ({ resource, id, meta }) => {
      const url = `${apiUrl}/${resource}/${id}`;
      try {
        const { data } = await httpClient.get(url);

        return {
          data,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    update: async ({ resource, id, variables }) => {
      const url = `${apiUrl}/${resource}/${id}`;
      try {
        const { data } = await httpClient.put(url, { ...variables });

        return {
          data,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    create: async ({ resource, variables, metaData, meta }) => {
      const url = "/cms/tags/addTeamTag";

      const { leagueId, teamId } = meta as { leagueId: number; teamId: number };

      try {
        await httpClient.post(url, {
          ...variables,
          leagueId: Number(leagueId),
          teamId: Number(teamId),
        });

        return Promise.resolve();
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    deleteOne: async ({ resource, id, meta }) => {
      const url = "/cms/tags/removeTeamTag";
      const { leagueId, teamId, tag } = meta as {
        leagueId: number;
        teamId: number;
        tag: string;
      };
      try {
        const { data } = await httpClient.post(url, {
          leagueId,
          teamId,
          tag,
        });
        return {
          data,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
  };
